import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { BreadcrumbsService } from './services/breadcrumbs.service';

/** @deprecated Superceded by `@suvo/frontend-framework/standalone/breadcrumb`. */
@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [BreadcrumbsComponent],
  providers: [BreadcrumbsService],
  exports: [BreadcrumbsComponent],
})
export class BreadcrumbsModule {}
